import { render, staticRenderFns } from "./CarTags.vue?vue&type=template&id=5e0a0276&scoped=true&"
import script from "./CarTags.vue?vue&type=script&lang=js&"
export * from "./CarTags.vue?vue&type=script&lang=js&"
import style0 from "./CarTags.vue?vue&type=style&index=0&id=5e0a0276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0a0276",
  null
  
)

export default component.exports